module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 20,
      "xs": 12
    }
  }, [(!_vm.collapsed) ? _c('img', {
    staticClass: "logoImg",
    attrs: {
      "src": require("../assets/sllogo.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sysName))])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v("\n            " + _vm._s(_vm.uName) + "\n          ")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.cpwd($event)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "prdName",
    on: {
      "click": function($event) {
        return _vm.jump('https://dist.yxcg.net')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mailiang.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prdName2"
  }, [_vm._v("买量")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "prdName",
    on: {
      "click": function($event) {
        return _vm.jump('https://sdk.yxcg.net')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mailiang2.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prdName2"
  }, [_vm._v("卖量")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "prdName",
    on: {
      "click": function($event) {
        return _vm.jump('https://tongji.yxcg.net')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tongji.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prdName2"
  }, [_vm._v("统计")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "prdName",
    on: {
      "click": function($event) {
        return _vm.jump('https://cloud.yxcg.net')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cloud.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prdName2"
  }, [_vm._v("云控")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "prdName prdName3",
    on: {
      "click": function($event) {
        return _vm.$router.push('/issuedApp/index')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/gamecenter.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prdName2"
  }, [_vm._v("游戏管理")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "prdName prdName3",
    on: {
      "click": function($event) {
        return _vm.jump('https://ucenter.yxcg.net')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/users.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prdName2"
  }, [_vm._v("用户中心")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "prdName prdName3",
    on: {
      "click": function($event) {
        return _vm.$router.push('/cpCompany/index')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cp.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prdName2"
  }, [_vm._v("CP管理")])])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.updatePwd2,
      "width": "400px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.updatePwd2 = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入原密码",
      "label-width": "120px",
      "prop": "old_password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.old_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "old_password", $$v)
      },
      expression: "form.old_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "label-width": "120px",
      "prop": "new_password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.new_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "new_password", $$v)
      },
      expression: "form.new_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "label-width": "120px",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "show-password": ""
    },
    model: {
      value: (_vm.form.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkPass", $$v)
      },
      expression: "form.checkPass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.updatePwd2 = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5cf95c3a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 568
// module chunks = 1